import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { useT } from "@/lib/i18n";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const [order, setOrder] = useState(null);
  const [status, setStatus] = useState(orderId ? "loading" : "error");
  const t = useT();

  useEffect(() => {
    if (!orderId) return;
    api.get(`/orders/public/${orderId}`)
      .then((r) => {
        setOrder(r.data);
        setStatus("placed");
      })
      .catch(() => setStatus("error"));
  }, [orderId]);

  return (
    <div className="min-h-screen bg-bone">
      <Navbar />
      <main className="max-w-2xl mx-auto px-6 py-24 text-center">
        {status === "loading" && (
          <div data-testid="payment-polling">
            <Loader2 className="w-10 h-10 animate-spin mx-auto text-forest" />
            <h1 className="mt-6 font-serif text-3xl text-forest font-bold">{t("confirming")}</h1>
            <p className="mt-2 text-charcoal/60">{t("payment_takes")}</p>
          </div>
        )}
        {status === "placed" && (
          <div data-testid="payment-success">
            <CheckCircle2 className="w-14 h-14 mx-auto text-moss" />
            <h1 className="mt-6 font-serif text-4xl text-forest font-bold">{t("order_placed")}</h1>
            <p className="mt-3 text-charcoal/70">
              {t("thank_you", { amount: Number(order?.total || 0).toFixed(2) })}
            </p>
            <div className="mt-2 text-xs text-charcoal/50 font-mono">
              {t("order_number")} #{order?.order_id?.slice(0, 8)}
            </div>
            <Link
              to="/"
              className="inline-block mt-8 px-6 py-3 rounded-full"
              style={{ backgroundColor: "var(--forest)", color: "#F9F8F6" }}
              data-testid="back-home-btn"
            >
              {t("back_to_shop")}
            </Link>
          </div>
        )}
        {status === "error" && (
          <div data-testid="payment-error">
            <h1 className="font-serif text-3xl text-forest font-bold">{t("payment_unclear")}</h1>
            <p className="mt-2 text-charcoal/70">{t("payment_unclear_desc")}</p>
            <Link
              to="/"
              className="inline-block mt-6 px-6 py-3 rounded-full"
              style={{ backgroundColor: "var(--forest)", color: "#F9F8F6" }}
            >
              {t("back_to_shop")}
            </Link>
          </div>
        )}
      </main>
    </div>
  );
}
